module.exports = __webpack_public_path__ + "static/media/2b2ca206-0945-4496-aa33-0291df649474.2faefaa3.jpeg";